import {Component, input, OnInit} from '@angular/core';
import {ProgressSpinner} from 'primeng/progressspinner';

/**
 * Simple wrapper around ProgressSpinner.
 *
 * Selector: `taspinner`
 *
 * Attributes:
 * - `size`: Defines the size of the spinner. Can be one of the following values:
 *    - `sm`: Small size.
 *    - `md`: Medium size (default).
 *    - `lg`: Large size.
 * - `pixelSize`: Allows a custom pixel size to be specified, overriding predefined sizes.
 *
 * Behavior:
 * - If `pixelSize` is provided, the spinner's size is determined by its value in pixels.
 * - If `pixelSize` is not provided, the size is determined by the `size` input value.
 */
@Component({
  selector: 'taspinner',
  imports: [ProgressSpinner],
  templateUrl: './taspinner.component.html',
  styleUrl: './taspinner.component.scss'
})
export class TaSpinnerComponent implements OnInit{

   size = input<'sm' |'md' | 'lg'>('md');
   pixelSize = input<number | undefined>();

   sizeString: string = '20px';



  ngOnInit(): void {

    if (this.pixelSize()) {
      this.sizeString = this.pixelSize() + 'px';
    }else{

      if (this.size() === 'sm') {
        this.sizeString = '18px';
      }else if (this.size() === 'md') {
        this.sizeString = '30px';
      }else if (this.size() === 'lg') {
        this.sizeString = '100px';
      }

    }


  }



}
